import { jsx as _jsx } from "react/jsx-runtime";
import { InfoBlock } from '@snack-uikit/info-block';
import styles from './styles.module.css';
export function ListEmptyState({ dataError, dataFiltered, hasNoItems, emptyStates, loading, size }) {
    if (loading) {
        return null;
    }
    if (dataError) {
        return (_jsx("div", { className: styles.listEmptyStateWrapper, children: _jsx(InfoBlock, Object.assign({}, emptyStates.errorDataState, { size: size, align: 'vertical' })) }));
    }
    if (dataFiltered && hasNoItems) {
        return (_jsx("div", { className: styles.listEmptyStateWrapper, children: _jsx(InfoBlock, Object.assign({}, emptyStates.noResultsState, { size: size, align: 'vertical', "data-test-id": 'list__no-results' })) }));
    }
    if (!dataFiltered && hasNoItems) {
        return (_jsx("div", { className: styles.listEmptyStateWrapper, children: _jsx(InfoBlock, Object.assign({}, emptyStates.noDataState, { size: size, align: 'vertical', "data-test-id": 'list__no-data' })) }));
    }
    return null;
}
